export default __webpack_public_path__ + "static/broadcastImg2-d3c51b1fcae42eecf497b63305b7d062.webp";